import { ConjunctionMode } from "@redotech/redo-customer-segments-common/segments/segment-types";
import { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { SegmentBuilderText } from "./segment-builder-text";

const conjunctionModeToFriendly: Record<ConjunctionMode, string> = {
  [ConjunctionMode.AND]: "All",
  [ConjunctionMode.OR]: "Any",
};

const options: RedoListItem<ConjunctionMode>[] = Object.values(
  ConjunctionMode,
).map((mode) => ({
  id: mode,
  type: "text",
  text: conjunctionModeToFriendly[mode],
  value: mode,
}));

interface BaseProps {
  mode: ConjunctionMode;
  textAfterConjunction?: string;
}
type SegmentConjunctionSelectorProps = BaseProps &
  (
    | { readonly: true }
    | { readonly?: false | undefined; setMode: (mode: ConjunctionMode) => void }
  );

export const SegmentConjunctionSelect = memo(
  function SegmentConjunctionSelector({
    mode,
    textAfterConjunction = "of these conditions must match a person",
    ...restProps
  }: SegmentConjunctionSelectorProps) {
    return (
      <Flex align="center">
        <Flex>
          <RedoSingleSelectDropdownInput
            disabled={restProps.readonly}
            fitToAnchor={false}
            options={options}
            optionSelected={({ item }) => {
              if (restProps.readonly) {
                return;
              }
              restProps.setMode(item.value);
            }}
            selectedItem={options.find((o) => o.id === mode)}
            size="xs"
          />
        </Flex>
        <SegmentBuilderText>{textAfterConjunction}</SegmentBuilderText>
      </Flex>
    );
  },
);
